module.exports = __webpack_public_path__ + "img/link_joker.2e0fcac4.png";